/**
 * Remember if tour already was shown
 *
 * @param {string} tourID - tour ID
 * */

export const setIsTourAlreadyShown = (tourID) => {
    // TODO: send value to the server
    localStorage.setItem(tourID, 'true');
};